import axios from "axios";

const GET_NPS_BY_SHORTCODE_URL = "https://api-weretail-store.azurewebsites.net/api/GetNPSByShortCode";

const lowerCaseKeys = (obj = {}) => {
    const lowered = {};
    Object.entries(obj || {}).forEach(([key, value]) => {
        if (!key) return;
        lowered[String(key).toLowerCase()] = value;
    });
    return lowered;
};

const coerceBoolean = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value !== 0;
    if (typeof value === "string") return value.toLowerCase() === "true";
    return false;
};

const safeParseJson = (value) => {
    if (typeof value === "string") {
        try {
            return JSON.parse(value);
        } catch (err) {
            return {};
        }
    }
    return typeof value === "object" && value !== null ? value : {};
};

const isAzureUnavailableResponse = (data) => {
    if (!data || typeof data !== "object") return true;

    const root = lowerCaseKeys(data);
    const status = String(root.status || "").toLowerCase().trim();
    const description = String(root.description || "").toLowerCase().trim();

    const hasJsonField = Object.prototype.hasOwnProperty.call(data, "json") || Object.prototype.hasOwnProperty.call(data, "Json");
    const rawJson = data.json ?? data.Json;
    const isEmptyJsonField =
        hasJsonField &&
        (rawJson === null ||
            rawJson === undefined ||
            (typeof rawJson === "string" && rawJson.trim() === "") ||
            (typeof rawJson === "object" && Object.keys(rawJson).length === 0));

    return status === "error" || description === "nps not found" || isEmptyJsonField;
};

const extractAzureNpsObject = (data) => {
    if (!data || typeof data !== "object") return data;

    const rawJsonField = data.json || data.Json;
    if (rawJsonField) {
        const parsed = safeParseJson(rawJsonField);
        if (parsed && Object.keys(parsed).length > 0) {
            return parsed;
        }
    }

    return data;
};

const buildNpsConfig = (payload) => {
    const normalized = lowerCaseKeys(payload);
    return {
        urlimage: normalized.urlimage || normalized.logo || normalized.image || "",
        primarycolor: normalized.primarycolor || "#021056",
        secondarycolor: normalized.secondarycolor || "#686868",
        fontfamily: normalized.fontfamily || "Quasimoda",
        recommendationquest: normalized.recommendationquest || normalized.recommendationquestion || "",
        sellerquestion: normalized.sellerquestion || "",
        productquestion: normalized.productquestion || "",
        howimprovetitle: normalized.howimprovetitle || "",
        title: normalized.title || "",
        thanktitle: normalized.thanktitle || "",
        thanktext: normalized.thanktext || "",
        thanksellerinstruction: normalized.thanksellerinstruction || "",
        thankshowsellerinfo: coerceBoolean(normalized.thankshowsellerinfo),
        showsellerquestion: coerceBoolean(normalized.showsellerquestion),
        showproductquestion: coerceBoolean(normalized.showproductquestion),
    };
};

const normalizeAzureResponse = (data, shortcode) => {
    if (!data) return null;
    if (isAzureUnavailableResponse(data)) return null;
    if (data.doc && data.doc.npsconfig) {
        return { ...data, shortcode: shortcode || data.shortcode || data.doc.shortcode || "" };
    }

    const azureData = extractAzureNpsObject(data);
    const root = lowerCaseKeys(azureData);
    const payload = safeParseJson(azureData.WhatsappPayload || azureData.whatsappPayload || azureData.whatsapppayload);
    const npsconfig = buildNpsConfig(payload);

    const doc = {
        npsid: root.id || root.npsid || root.nps || shortcode || "",
        shortcode: shortcode || root.shortcode || "",
        or: root.or || root.organization || "",
        customerfirstname: root.customerfirstname || root.nomecliente || root.customername || root.customer || "",
        storename: root.storename || root.nomeloja || root.loja || "",
        sellername: root.sellername || root.nomevendedor || root.seller || "",
        seller: root.seller || root.sellername || root.nomevendedor || "",
        phonenumber: root.phonenumber || root.fonecliente || root.phone || root.sellerphone || root.whatsapp || "",
        npsconfig,
    };

    const answeredFlag =
        coerceBoolean(root.alreadyanswered ?? root.answered ?? root.hasanswer ?? root.answeredflag) || Boolean(root.answer);

    return {
        status: root.status || (answeredFlag ? "already ansewered" : ""),
        answered: answeredFlag,
        shortcode: doc.shortcode,
        doc,
    };
};

async function getNPSData({ shortcode } = {}) {
    if (!shortcode) {
        return null;
    }

    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    };

    const url = new URL(GET_NPS_BY_SHORTCODE_URL);
    url.searchParams.set("code", "WKvx6Yb1UPtXNJhm3MRzI7wdzbIrhTBuIr0grxWcoA0LAzFurSdeUA==");
    try {
        const { data } = await axios.post(url.toString(), { shortcode, shortCode: shortcode }, options);
        return normalizeAzureResponse(data, shortcode);
    } catch (err) {
        return null;
    }
}

export default getNPSData;
